export default __webpack_public_path__ + "static/media/Draft-Player.6ff6e535.png";